module.exports = __webpack_public_path__ + "static/media/info_marketing.b99c185d.png";